import {createSelector} from 'reselect';
import {getLocaleFromSiteDataV2} from './selectors';

const isArabicLanguageLocale = createSelector(
  [getLocaleFromSiteDataV2],
  (locale) => {
    const language = typeof locale === 'string' && locale?.split('_')[0].toLowerCase();
    return language ? language === 'ar' : false;
  },
);

export default isArabicLanguageLocale;
